import { z } from "zod";
import { payment } from "../validators";

export const serverResponse = z.array(payment);
